module.exports = __webpack_public_path__ + "static/media/cb.662b18bf.png";